import React from 'react';
import Selector from '../util/Selector';

const FORMATS = [
  { name: 'csv', display: 'CSV: Comma-separated values (Excel)' },
  { name: 'json', display: 'JSON: A list of point objects (Python, Node, etc.)' },
  {
    name: 'ndjson',
    display: 'ND-JSON: Newline-separated JSON point objects, for large datasets (Python)',
  },
];

const FormatSelector = ({ selected, onChange }) => (
  <Selector
    options={FORMATS.map(({ name, display }) => ({
      id: name,
      key: name,
      display,
    }))}
    selected={selected ? `${selected}` : ''}
    onChange={({ target: { value } }) => onChange(value)}
  />
);

export default FormatSelector;
